export default (state: any, action: any) => ({
  ...state,
  leadsPool: {
    ...state.leadsPool,
    isLoading: action.isLoading,
  },
});
